/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioTiposUnidadesCV from './controladorVista/formularioTiposUnidadesCV';
import TablaTiposUnidadesCV from './controladorVista/tablaTiposUnidadesCV';
import { estadoIncial, reductor } from './reductorTiposUnidades';

const TiposUnidades: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTiposUnidadesCV />
        <FormularioTiposUnidadesCV />
    </ProveedorEstado>
);

export default TiposUnidades;
